import * as yup from 'yup';
import {
  CreateInsuredPayloadDto,
  CreateInsuredPayloadDtoStatusEnum,
} from 'libs/pinnacle-sdk';
import { TFunction } from 'i18next';

export const getValidationSchema = (t: TFunction) =>
  yup.object().shape({
    status: yup
      .string()
      .required(t('validation.required', { field: t('general.status') })),
    name: yup
      .string()
      .trim()
      .required(t('validation.required', { field: t('insured.insuredName') })),
    country: yup
      .string()
      .required(t('validation.required', { field: t('general.country') })),
    city: yup.string(),
    postcode: yup
      .string()
      .test(
        'empty-or-numeric',
        t('validation.numeric', { field: t('general.postcode') }),
        (value) => value === '' || value === undefined || /^\d+$/.test(value)
      )
      .max(
        10,
        t('validation.maxLength', { field: t('general.postcode'), length: 10 })
      ),
    address: yup.string(),
    sanctionsCompleted: yup
      .boolean()
      .required(
        t('validation.required', { field: t('insured.sanctionsStatus') })
      ),
    sanctionsCompletedDate: yup.date().when('sanctionsCompleted', {
      is: true,
      then: () =>
        yup.date().required(
          t('validation.required', {
            field: t('insured.sanctionsCompletionDate'),
          })
        ),
      otherwise: () => yup.date().nullable(),
    }),
    comment: yup.string(),
    state: yup.string(),
  });

export const initialValues = {
  status: CreateInsuredPayloadDtoStatusEnum.Active,
  name: undefined,
  country: undefined,
  city: undefined,
  postcode: undefined,
  address: undefined,
  sanctionsCompleted: undefined,
  sanctionsCompletedDate: undefined,
  comment: undefined,
  state: undefined,
};

export const fields = Object.keys(
  initialValues
) as (keyof CreateInsuredPayloadDto)[];
